"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationButton = exports.PaginationGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var enums_1 = require("../../enums");
var BootstrapHelper_1 = require("../../BootstrapHelper");
function getPageList(totalPages, page, maxLength) {
    if (maxLength < 5)
        throw new Error("maxLength must be at least 5");
    function range(start, end) {
        return Array.from(Array(end - start + 1), function (_, i) { return i + start; });
    }
    var sideWidth = maxLength < 9 ? 1 : 2;
    var leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    var rightWidth = (maxLength - sideWidth * 2 - 2) >> 1;
    if (totalPages <= maxLength) {
        // no breaks in list
        return range(1, totalPages);
    }
    if (page <= maxLength - sideWidth - 1 - rightWidth) {
        // no break on left of page
        return range(1, maxLength - sideWidth - 1).concat(0, range(totalPages - sideWidth + 1, totalPages));
    }
    if (page >= totalPages - sideWidth - 1 - rightWidth) {
        // no break on right of page
        return range(1, sideWidth).concat(0, range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages));
    }
    // Breaks on both sides
    return range(1, sideWidth).concat(0, range(page - leftWidth, page + rightWidth), 0, range(totalPages - sideWidth + 1, totalPages));
}
var PaginationGroup = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("pagination")
        .pmod(props.position || enums_1.UiPositions.RIGHT).bem;
    return ((0, jsx_runtime_1.jsx)("nav", { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: "".concat(cls) }, { children: props.children })) }));
};
exports.PaginationGroup = PaginationGroup;
var PaginationButton = function (props) {
    return ((0, jsx_runtime_1.jsx)("li", __assign({ className: "page-item ".concat(props.status || ""), onClick: props.onClick }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "page-link" }, { children: props.children })) })));
};
exports.PaginationButton = PaginationButton;
var s = {
    Button: exports.PaginationButton,
    Group: exports.PaginationGroup,
    getPageList: getPageList
};
exports.default = s;
